/**
 * Класс возврата конфигурации системы. Расположение может быть неоптимальным, код тоже (TypeScript я не знаю).
 * Рекомендуется просмотреть и сделать красиво и правильно (ну и лишние комментарии поудалять).
 *
 * Импорт:
 *    import $config from "./config";
 *
 * Использование:
 *    if ($config.debugMode & $config.D_MSG) { console.log('Сообщение о ходе выполнения программыю.') }
 * или
 *    if ($config.debugMode & $config.D_ERR) { console.log('Ошибка.') }
 */

// NOTE(vmunt): Конфигурацию терминалов из файла src/redux/reducer.ts / src/temp/data/data.ts сюда выносить, наверное,
// не надо, ибо зачем светить на произвольном клиенте конфигурацию всех зарегистрированных в системе клиентов?
// Но содержимое tsconfig.json сюда перенести, думаю, можно.
//
// NOTE(vmunt): Также в текстах справки src/components/PayDebtPage/PayDebtPage.tsx
// хардкод с URL со streampay в текстах нужно поменять на вставку строки $config.baseURL.

const origin = window.location.origin; // href (http://cashier/home), origin (http://cashier), host, hostname (cashier), port (''), pathname ("/home")
let baseURL; // Так как весь клиентский код у нас работает только с со своим доменным именем,
// то для инициализаци axios достаточно просто взять текущее доменное имя из window или из document.

const D_NONE = 0b0000; // Не выводить ничего (все битовые флаги выключены).
const D_ERR = 0b0001; // Выводить сообщения об ошибках
const D_WARN = 0b0010; // Выводить предупреждения
const D_INF = 0b0100; // Информация о содержимом важных переменных и объектов.
const D_MSG = 0b1000; // Прочие сообщения и шаги выполнения программы.
const D_ALL = 0b1111; // Все сообщения (маска, содержащая все битовые флаги)
let debugMode = D_ERR; // В консоль выводим информацию о возникающих ошибках (по умолчанию).
let environmentMode; // Строковое имя текущего окружения: 'Sandbox', 'Staging', 'Dev', 'Dev2' или undefined (для Prod). Если переменная не определена, значит баннер не отображается.

switch (
    origin // Пока домен единственный, этот switch() заменяется одной строкой baseURL = window.location.href.
) {
    // Отладочные домены должны отправлять запросы работоспособному серверу.
    // Sandbox
    case 'http://localhost:3003':
    case 'https://streampay.kkmport.kz:4443':
        baseURL = 'https://streampay.kkmport.kz:4447/'; // Временно 4447, сначала нужно разобраться с 4443 в nginx
        debugMode = D_ALL;
        environmentMode = 'Sandbox';
        break;
    // Staging
    case 'http://localhost:3002':
    case 'https://streampay.kkmport.kz:4447':
        baseURL = 'https://streampay.kkmport.kz:4447/';
        debugMode = D_ALL;
        environmentMode = 'Staging';
        break;
    // Dev
    case 'http://localhost:3000':
    case 'https://node01.kmpkz.idc.asv:4448':
        baseURL = 'https://node01.kmpkz.idc.asv:4448/';
        debugMode = D_ALL;
        environmentMode = 'Dev';
        break;
    // Dev2
    case 'http://localhost:3001':
    case 'https://node01.kmpkz.idc.asv:4449':
        baseURL = 'https://node01.kmpkz.idc.asv:4449/';
        debugMode = D_ALL;
        environmentMode = 'Dev2';
        break;
    // Dev3
    case 'http://localhost:3005':
    case 'https://node01.kmpkz.idc.asv:4450':
        baseURL = 'https://node01.kmpkz.idc.asv:4450/';
        debugMode = D_ALL;
        environmentMode = 'Dev3';
        break;
    // Prod
    case 'http://localhost:3004':
        baseURL = 'https://streampay.kkmport.kz:443/';
        debugMode = D_ALL;
        break;
    default:
        baseURL = origin + '/';
}

// Конфигурация интерфейса.
const $config = {
    // NOTE(vmunt): Статических переменных не обнаружено (чтобы вычислить и сохранить значения один раз), поэтому вычисляем
    // значения каждый раз. Некритично, так как требуется редко, кода мало, и выполняется это всё на клиенте, а не на сервере.
    baseURL: baseURL,
    debugMode: debugMode, // Маска, какие из консольных сообщений выводить в консоль JS.
    D_NONE: D_NONE, // NOTE(vmunt): Доступность глобальных переменных в React не проверял, поэтому гарантированное использование через свойства объекта.
    D_ERR: D_ERR,
    D_WARN: D_WARN,
    D_INF: D_INF,
    D_MSG: D_MSG,
    D_ALL: D_ALL,

    //helpURL: origin, // Локальный сайт может понадобиться для формирования подсказок в PayDebtPage.tsx при запуске системы на разработческих доменах.
    payURL: 'https://3dsecure.bcc.kz:5443/cgi-bin/cgi_link', // prod, для PayDebtPage.tsx:187.
    offerURL: '/offer.pdf',
    environmentMode: environmentMode,
};

export default $config;
